import styled from 'styled-components/macro';

const LabelLight = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.neutral05};
  line-height: 16px;
  text-align: left;
`;

export default LabelLight;
